export enum RecurrenceType {
    Every = "Every",
    SpecificDays = "SpecificDays",
    SpecificDates = "SpecificDates"
}